/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsSafetiesIncidentTemplateData } from '../../models/mail-params-safeties-incident-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendSafetiesIncidentMail$Params {
      body: MailParamsSafetiesIncidentTemplateData
}

export function sendSafetiesIncidentMail(http: HttpClient, rootUrl: string, params: SendSafetiesIncidentMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendSafetiesIncidentMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendSafetiesIncidentMail.PATH = '/sendMail/safeties-incident-notification';
